import {
  AppBase,
  baseFromDoc,
  FirestoreBaseDoc,
  makeDocConverter,
} from '../../base/firestore-model-base'

/**
 * SchoolMemo（学校への管理者メモ）
 *
 * - `SchoolMemoDoc`: Firestore に保存される形（snake_case / Timestamp）
 * - `SchoolMemo`: アプリで扱う形（camelCase / Date）
 *
 * 保存先: school_accounts/{schoolAccountId}/memos/{memoId}
 */

export type SchoolMemoDoc = FirestoreBaseDoc & {
  sender_name: string
  content: string
}

export type SchoolMemo = AppBase & {
  senderName: string
  content: string
}

export const schoolMemoDocConverter = makeDocConverter<SchoolMemoDoc>()

export function toSchoolMemo(id: string, doc: SchoolMemoDoc, path: string): SchoolMemo {
  const base = baseFromDoc(id, doc, path)
  return {
    ...base,
    senderName: doc.sender_name,
    content: doc.content,
  }
}
